import { State } from "../../../redux/state";

export const youtubeRoot = (state: State) => state.youtube;

export const youtubeSettingsSelector = (state: State) =>
  youtubeRoot(state).settings;

export const youtubeDirectPostDraftSelector = (state: State) =>
  youtubeRoot(state).directPostDraft;
